module.exports = __webpack_public_path__ + "static/media/fedpa-vest.0b778f99.svg";